import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { RedemptionReportingApplicationsComponent } from './components/redemptions-reporting-applications.component';
import { RedemptionSiteTrafficComponent } from './components/redemptions-site-traffic.component';

@NgModule({
    declarations: [RedemptionReportingApplicationsComponent, RedemptionSiteTrafficComponent],
  imports: [
      CommonModule,
      SharedModule
  ]
})
export class RedemptionReportingModule { }
